import { v4 as uuidv4 } from 'uuid';
import { events, selectors, formatStr, trackEvent } from '../analytics-helpers';
class StepForm {
  constructor({ dom }) {
    this.dom = {
      ...dom
    };

    this.dom.$stepForm = document.querySelector('.step-form');
    this.dom.$stepFormHeading = document.querySelector(
      '.step-form__step-label'
    );
    this.dom.$form = document.querySelector('.step-form__form');
    this.dom.$steps = document.querySelectorAll('.step-form__step');
    this.dom.$sections = document.querySelectorAll(
      '.step-form__section-wrapper'
    );
    this.dom.$progressBar = document.querySelector('.step-form__bar');
    this.dom.$backBtn = document.querySelector('.step-form__back');
    this.dom.$nextBtn = document.querySelector('.step-form__next');
    this.currentStep = 1;
    this.isFirstRender = true;

    if (this.dom.$stepForm) {
      this.nextBtnCurrentLabel =
        this.dom.$nextBtn.querySelector('.btn__label').textContent;
      this.getForm();
      this.addListeners();
    }
  }

  addListeners() {
    this.dom.$backBtn.addEventListener('click', this.backStep.bind(this));
    this.dom.$nextBtn.addEventListener('click', this.nextStep.bind(this));
  }

  getForm() {
    fetch(this.dom.$stepForm.dataset.endpoint)
      .then(data => data.json())
      .then(res => {
        this.formResponse = res;
        this.renderForm();
        this.updateBarLength();
        this.updateText();
        this.validateRequired();
      });
  }

  renderForm() {
    const { Copy, Heading, Type, Answers, RequiredStep, Subheading } =
      this.formResponse;
    const firstRender = this.renderQuestions(
      Copy,
      Heading,
      Type,
      Answers,
      RequiredStep,
      Subheading
    );
    this.dom.$form.innerHTML += firstRender;
    this.isFirstRender = false;
    const branchBtn = document.querySelectorAll('.step-form__branching-input');
    branchBtn.map(el => {
      el.addEventListener('click', this.childRenderer.bind(this));
    });
  }

  renderQuestions(
    Copy,
    Heading,
    Type,
    Answers,
    RequiredStep,
    SkipNextIfEmpty,
    Subheading
  ) {
    if (Type && Answers) {
      let inputId;
      switch (Type) {
        case 'Branching Stepped Question':
          return `
          <div tabindex="-1" data-skip="${SkipNextIfEmpty}" class="step-form__section-wrapper step-form__branching-step ${
            !this.isFirstRender && 'step-form__hidden'
          }">
          <div class="step-form__heading-wrapper">
            <span class="step-form__step-label">${this.headingHandler(
              Subheading
            )}</span>
          </div>
            <h2 class="step-form__question-label">${Heading}</h2>
            <section class="rich-text-row rtf container step-form__copy"><p>${Copy}</p></section>
            <div class="step-form__step step-form__section">
            ${Answers.map(el => {
              inputId = uuidv4();
              return `<div class="field radio step-form__checkbox">
                <input value="${
                  el.AnswerTitle
                }" class="field__checkbox step-form__branching-input" data-input-key="${
                el.AnswerKey
              }" id="${inputId}" name="${Heading}" type="radio" ${
                RequiredStep ? 'required="true"' : null
              }>
                <div class="field__input-label-wrapper">
                  <span class="field__faux-checkbox"></span>
                  <label for="${inputId}" class="field__label">
                    <picture class="step-form__icon">
                      <img src="${el.AnswerImageSrc}" alt="${el.AnswerTitle}">
                    </picture>
                    <span class="step-form__text">${el.AnswerTitle}</span>
                  </label>
                </div>
              </div>`;
            }).join('')}
          </div>
          </div>
        `;
        case 'Checkbox Stepped Question':
          return `
        <div tabindex="-1" data-skip="${SkipNextIfEmpty}" class="step-form__section-wrapper ${
            !this.isFirstRender && 'step-form__hidden'
          }">
        <div class="step-form__heading-wrapper">
          <span class="step-form__step-label">${this.headingHandler(
            Subheading
          )}</span>
        </div>
          <h2 class="step-form__question-label">${Heading}</h2>
          <section class="rich-text-row rtf container step-form__copy"><p>${Copy}</p></section>
          <div class="step-form__step step-form__section step-form__section-no-icon">
            ${Answers.map(el => {
              inputId = uuidv4();
              return `<div class="field checkbox step-form__radio-no-icon">
                <input value="${
                  el.AnswerTitle
                }" class="field__checkbox step-form__checkbox-input" data-input-key="${
                el.AnswerKey
              }" id="${inputId}" name="${Heading}" type="checkbox" ${
                RequiredStep ? 'required="true"' : null
              }>
                <div class="field__input-label-wrapper">
                  <span class="field__faux-checkbox"></span>
                  <label for="${inputId}" class="field__label">
                    <span class="step-form__text">${el.AnswerTitle}</span>
                  </label>
                </div>
              </div>`;
            }).join('')}
          </div>
        </div>
        `;
        case 'Radio Stepped Question':
          return `
        <div tabindex="-1" data-skip="${SkipNextIfEmpty}" class="step-form__section-wrapper ${
            !this.isFirstRender && 'step-form__hidden'
          }">
        <div class="step-form__heading-wrapper">
          <span class="step-form__step-label">${this.headingHandler(
            Subheading
          )}</span>
        </div>
          <h2 class="step-form__question-label">${Heading}</h2>
          <section class="rich-text-row rtf container step-form__copy"><p>${Copy}</p></section>
          <div class="step-form__step step-form__section step-form__section-no-icon">
            ${Answers.map(el => {
              inputId = uuidv4();
              return `<div class="field radio step-form__radio-no-icon">
                <input value="${
                  el.AnswerTitle
                }" class="field__checkbox step-form__radio-input" data-input-key="${
                el.AnswerKey
              }" id="${inputId}" name="${Heading}" type="radio" ${
                RequiredStep ? 'required="true"' : null
              }>
                <div class="field__input-label-wrapper">
                  <span class="field__faux-checkbox"></span>
                  <label for="${inputId}" class="field__label">
                    <span class="step-form__text">${el.AnswerTitle}</span>
                  </label>
                </div>
              </div>`;
            }).join('')}
          </div>
        </div>
        `;
        case 'Text Stepped Question':
          inputId = uuidv4();
          return `
          <div tabindex="-1" data-skip="${SkipNextIfEmpty}" class="step-form__section-wrapper step-form__textarea ${
            !this.isFirstRender && 'step-form__hidden'
          }">
          <div class="step-form__heading-wrapper">
            <span class="step-form__step-label">${this.headingHandler(
              Subheading
            )}</span>
          </div>
            <h2 class="step-form__question-label">${Heading}</h2>
            <section class="rich-text-row rtf container step-form__copy"><p>${Copy}</p></section>
            <div class="step-form__step">
            <div class="field step-form__textarea-input">
              <div class="field__input-label-wrapper">
              <label for="${Answers[0].AnswerTitle}" class="field__label">${
            Answers[0].AnswerTitle
          }</label>
              <textarea id="${inputId}" name="${Heading}" class="field__input field__textarea" value=""></textarea>
              </div>
            </div>
          </div>
          </div>
        `;
        case 'Radio Stepped Question With Image':
          return `
          <div tabindex="-1" data-skip="${SkipNextIfEmpty}" class="step-form__section-wrapper ${
            !this.isFirstRender && 'step-form__hidden'
          }">
          <div class="step-form__heading-wrapper">
            <span class="step-form__step-label">${this.headingHandler(
              Subheading
            )}</span>
          </div>
            <h2 class="step-form__question-label">${Heading}</h2>
            <section class="rich-text-row rtf container step-form__copy"><p>${Copy}</p></section>
            <div class="step-form__step step-form__section">
            ${Answers.map(el => {
              inputId = uuidv4();
              return `<div class="field radio step-form__checkbox">
                <input value="${
                  el.AnswerTitle
                }" class="field__checkbox step-form__radio-input" data-input-key="${
                el.AnswerKey
              }" id="${inputId}" name="${Heading}" type="radio" ${
                RequiredStep ? 'required="true"' : null
              }>
                <div class="field__input-label-wrapper">
                  <span class="field__faux-checkbox"></span>
                  <label for="${inputId}" class="field__label">
                    <picture class="step-form__icon">
                      <img src="${el.AnswerImageSrc}" alt="${el.AnswerTitle}">
                    </picture>
                    <span class="step-form__text">${el.AnswerTitle}</span>
                  </label>
                </div>
              </div>`;
            }).join('')}
          </div>
          </div>
        `;
      }
    }
  }

  headingHandler(Subheading) {
    let singleString = Subheading;

    if (this.isFirstRender) {
      singleString = this.formResponse.Subheading;
    }

    if (singleString) {
      const headingWrapper = document.createElement('div');
      const stringCurrent = `<span class="step-form__current">${
        this.currentStep - 1
      }</span>`;
      const stringTotal = `<span class="step-form__total">${
        document.querySelectorAll('.step-form__step').length - 1
      }</span>`;
      const singleStringFormat = singleString.replace('{0}', stringCurrent);
      const fullString = singleStringFormat.replace('{1}', stringTotal);
      headingWrapper.innerHTML = fullString;
      return headingWrapper.innerHTML;
    }

    return '';
  }

  backStep() {
    if (this.currentStep > 1) {
      this.validateStep();
      this.validateBackSkip();
      this.currentStep--;
      this.updateBarLength();
      this.updateText();
      this.validateStep();
      this.validateRequiredNext();
      this.resetFocus();
    }
  }

  childRenderer() {
    const hiddenStep = document.querySelectorAll('.step-form__hidden');
    if (hiddenStep) {
      hiddenStep.map(el => {
        el.remove();
      });
    }
    const choice = document.querySelector(
      '.step-form__branching-input:checked'
    );
    const choiceId = choice.id;
    const questions = this.formResponse.Answers.find(
      obj => obj.AnswerTitle === choice.value
    );
    questions.Questions.map(el => {
      const {
        Copy,
        Heading,
        Type,
        Answers,
        RequiredStep,
        SkipNextIfEmpty,
        Subheading
      } = el;
      const subStep = this.renderQuestions(
        Copy,
        Heading,
        Type,
        Answers,
        RequiredStep,
        SkipNextIfEmpty,
        Subheading
      );
      this.dom.$form.innerHTML += subStep;
    });
    document.getElementById(choiceId).checked = true;
    document.getElementById(choiceId).focus();
    this.updateBarLength();
    this.updateText();
    this.updateBarLength();

    const branchInput = document.querySelectorAll(
      '.step-form__branching-input'
    );

    branchInput.map(el => {
      el.addEventListener('click', () => {
        this.childRenderer();
      });
    });
  }

  validateRequired() {
    const currentStep = document.querySelectorAll(
      '.step-form__section-wrapper'
    )[this.currentStep - 1];
    const input = document
      .querySelectorAll('.step-form__section-wrapper')
      [this.currentStep - 1].querySelector('.step-form__section');
    if (input) {
      const radios = input.querySelectorAll('input[type="radio"]');
      const checkboxes = input.querySelectorAll('input[type="checkbox"]');
      const checkedRadio = Array.prototype.slice
        .call(radios)
        .some(x => x.checked);
      const checkedBox = Array.prototype.slice
        .call(checkboxes)
        .some(x => x.checked);

      if (
        (input.querySelector('input').required && checkedRadio) ||
        checkedBox
      ) {
        this.dom.$nextBtn.disabled = false;
      } else if (input.querySelector('input').required) {
        this.dom.$nextBtn.disabled = true;
        radios.map(e => {
          e.addEventListener('click', () => {
            this.dom.$nextBtn.disabled = false;
          });
        });

        checkboxes.map(e => {
          e.addEventListener('click', () => {
            this.dom.$nextBtn.disabled = !this.dom.$nextBtn.disabled;
          });
        });
      } else {
        this.dom.$nextBtn.disabled = false;
        if (currentStep.dataset.skip === 'true') {
          this.currentStep++;
        }
      }
    }
  }

  validateRequiredNext() {
    const input = document
      .querySelectorAll('.step-form__section-wrapper')
      [this.currentStep - 1].querySelector('.step-form__section');
    if (input) {
      const radios = input.querySelectorAll('input[type="radio"]');
      const checkboxes = input.querySelectorAll('input[type="checkbox"]');
      const checkedRadio = Array.prototype.slice
        .call(radios)
        .some(x => x.checked);
      const checkedBox = Array.prototype.slice
        .call(checkboxes)
        .some(x => x.checked);

      if (
        (input.querySelector('input').required && checkedRadio) ||
        checkedBox
      ) {
        this.dom.$nextBtn.disabled = false;
      } else if (input.querySelector('input').required) {
        this.dom.$nextBtn.disabled = true;
        radios.map(e => {
          e.addEventListener('click', () => {
            this.dom.$nextBtn.disabled = false;
          });
        });

        checkboxes.map(e => {
          e.addEventListener('click', () => {
            this.dom.$nextBtn.disabled = !this.dom.$nextBtn.disabled;
          });
        });
      } else {
        this.dom.$nextBtn.disabled = false;
      }
    }
  }

  validateNext() {
    const input = document
      .querySelectorAll('.step-form__section-wrapper')
      [this.currentStep - 1].querySelector('.step-form__section');
    const radios = input.querySelectorAll('input[type="radio"]');
    const checkboxes = input.querySelectorAll('input[type="checkbox"]');
    const checkedRadio = Array.prototype.slice
      .call(radios)
      .some(x => x.checked);
    const checkedBox = Array.prototype.slice
      .call(checkboxes)
      .some(x => x.checked);

    if (input && input.querySelector('input').required) {
      if (checkedRadio || checkedBox) {
        this.nextStepHandler();
      }
    } else {
      this.nextStepHandler();
    }
  }

  validateBackSkip() {
    if (this.currentStep - 2 >= 1) {
      const filledSteps = document.querySelectorAll(
        '.step-form__section-wrapper'
      )[this.currentStep - 3];
      const input = filledSteps.querySelector('.step-form__section');
      if (input) {
        const radios = input.querySelectorAll('input[type="radio"]');
        const checkboxes = input.querySelectorAll('input[type="checkbox"]');
        const checkedBox = Array.prototype.slice
          .call(checkboxes)
          .some(x => x.checked);

        if (filledSteps.dataset.skip === 'true' && !checkedBox) {
          this.currentStep--;
        }
      }
    }
  }

  getFormResults() {
    const formSteps = document.querySelectorAll('.step-form__section-wrapper');
    const branchVal = document.querySelector(
      '.step-form__branching-input:checked'
    );
    const formResults = {
      Type: branchVal.dataset.inputKey,
      Answers: []
    };
    formSteps.map(el => {
      if (el.querySelector('.step-form__checkbox-input')) {
        const answerList = [];
        const checkboxVal = el.querySelectorAll(
          '.step-form__checkbox-input:checked'
        );
        checkboxVal.map(el => {
          answerList.push(el.dataset.inputKey);
        });
        const type = 'Checkbox';
        const checkboxQuestion = el.querySelector('.step-form__checkbox-input');
        if (checkboxQuestion) {
          const answerObj = {
            Question: checkboxQuestion.name,
            Type: type,
            Answers: answerList
          };
          formResults.Answers.push(answerObj);
        } else {
          const answerObj = {
            Question: checkboxQuestion.name,
            Type: type,
            Answers: []
          };
          formResults.Answers.push(answerObj);
        }
      }

      if (el.querySelector('.step-form__radio-input')) {
        const answerList = [];
        const radioVal = el.querySelector('.step-form__radio-input:checked');
        if (radioVal) {
          answerList.push(radioVal.dataset.inputKey);
        }
        const type = 'Radio';
        const checkboxQuestion = el.querySelector('.step-form__radio-input');
        if (checkboxQuestion) {
          const answerObj = {
            Question: checkboxQuestion.name,
            Type: type,
            Answers: answerList
          };
          formResults.Answers.push(answerObj);
        } else {
          const answerObj = {
            Question: checkboxQuestion.name,
            Type: type,
            Answers: []
          };
          formResults.Answers.push(answerObj);
        }
      }

      if (el.querySelector('.field__textarea')) {
        const answerList = [];
        const textVal = el.querySelector('.field__textarea');
        answerList.push(textVal.value);
        const type = 'Text';
        const checkboxQuestion = el.querySelector('.field__textarea');
        if (checkboxQuestion) {
          const answerObj = {
            Question: checkboxQuestion.name,
            Type: type,
            Answers: answerList
          };
          formResults.Answers.push(answerObj);
        } else {
          const answerObj = {
            Question: checkboxQuestion.name,
            Type: type,
            Answers: []
          };
          formResults.Answers.push(answerObj);
        }
      }
    });
    this.results = formResults;
    this.sendForm();
  }

  sendForm() {
    const postHeaders = new Headers();
    postHeaders.append('Accept', 'application/json');
    postHeaders.append('Content-Type', 'application/json');
    trackEvent({
      event: `${events.careQuestionnareStep}${
        document.querySelectorAll(selectors.careQuestionareSection).length - 1
      }`,
      care_questionnare_selection: formatStr(
        document.querySelector(selectors.careQuestionareTextarea).value || ''
      )
    });
    trackEvent({
      event: events.careQuestionnareComplete
    });
    fetch(this.dom.$stepForm.dataset.endpoint, {
      method: 'POST',
      headers: postHeaders,
      body: JSON.stringify(this.results)
    })
      .then(response => response.json())
      .then(result => {
        window.location.href = result.Link;
      })
      .catch(error => location.reload());
  }

  nextStep() {
    if (
      this.currentStep < document.querySelectorAll('.step-form__step').length
    ) {
      this.validateNext();
    } else {
      this.getFormResults();
    }
  }

  nextStepHandler() {
    this.validateStep();
    this.validateRequired();
    this.fireTrackingEvents();
    this.currentStep++;
    this.updateBarLength();
    this.updateText();
    this.validateStep();
    this.validateRequiredNext();
    this.resetFocus();
  }

  fireTrackingEvents() {
    if (this.currentStep - 1 === 0) {
      const activeSection = document
        .querySelectorAll(selectors.careQuestionareSection)
        .at(0);
      const sectionValues = Array.from(
        activeSection.querySelectorAll(selectors.careQuestionareSelected)
      )
        .map(input => input.value)
        .join(', ');
      trackEvent({
        event: events.careQuestionareStart,
        care_questionnare_selection: formatStr(sectionValues)
      });
    } else {
      const activeSection = document
        .querySelectorAll(selectors.careQuestionareSection)
        .at(this.currentStep - 1);
      const sectionValues = Array.from(
        activeSection.querySelectorAll(selectors.careQuestionareSelected)
      )
        .map(input => input.value)
        .join(', ');
      trackEvent({
        event: `${events.careQuestionnareStep}${this.currentStep - 1}`,
        care_questionnare_selection: formatStr(sectionValues)
      });
    }
  }

  validateStep() {
    document
      .querySelectorAll('.step-form__section-wrapper')
      [this.currentStep - 1].classList.toggle('step-form__hidden');
  }

  ruleOfThree(total, currentStep) {
    const proportion = (currentStep * 100) / total;
    return Math.round(proportion * 10) / 10;
  }

  updateText() {
    const currentHeading = document.querySelectorAll(
      '.step-form__heading-wrapper'
    );
    if (currentHeading) {
      currentHeading.map(el => {
        const currentText = el.querySelector('.step-form__current');
        const totalText = el.querySelector('.step-form__total');
        if (currentText && totalText) {
          currentText.textContent = this.currentStep - 1;
          totalText.textContent =
            document.querySelectorAll('.step-form__step').length - 1;
        }
      });
    }
  }

  resetFocus() {
    const step = document.querySelector(
      '.step-form__section-wrapper:not(.step-form__hidden)'
    );
    step.focus();
  }

  updateBarLength() {
    if (this.currentStep === 1 && !this.dom.$backBtn.disabled) {
      this.dom.$backBtn.disabled = true;
    } else {
      this.dom.$backBtn.disabled = false;
    }

    if (
      this.currentStep === document.querySelectorAll('.step-form__step').length
    ) {
      this.dom.$nextBtn.querySelector('.btn__label').textContent =
        this.dom.$stepForm.dataset.nextBtnLabel;
    } else {
      this.dom.$nextBtn.querySelector('.btn__label').textContent =
        this.nextBtnCurrentLabel;
    }

    if (this.currentStep === 1) {
      this.dom.$progressBar.style.width = '0%';
    } else {
      const percentage = this.ruleOfThree(
        document.querySelectorAll('.step-form__step').length,
        this.currentStep
      );
      this.dom.$progressBar.style.width = `${percentage}%`;
    }
  }
}

export default StepForm;
